import * as fabric from 'office-ui-fabric-react';
import { IDropdownOption } from 'office-ui-fabric-react';
import React, { FC } from 'react';
import * as enums from '../../../enums';
import { QueuePriority, TicketAction } from '../../../enums';
import '../../../styles/pages/QueueManagementPage.scss';
import { ITicket } from '../model';
import { useTickets } from './context/TicketsContext';
import QueueTicketBar from './QueueTicketBar';

interface IQueueProps {
    assignedTicket: ITicket | null;
    moveTicketToLocation(ticketId: number, newState: enums.TicketState): void;
    removeTicketFromQueue(ticketId: number, priority?: QueuePriority): void;
    openSendToQueueModalWindow(ticket: ITicket): void;
    setSelectedTicket(ticket: ITicket): void;
    selectedTicket: ITicket | null;
    setLocationStatus(value: number): void;
}

export enum ChoiceEnum {
    ByArrivalTime = 1,
    ByVisitTime = 2
}

export interface IFilterSettings {
    serviceFilterOptionKeys: IDropdownOption[];
    choiceGroupValue: ChoiceEnum;
}

const Queue: FC<IQueueProps> = (props: IQueueProps) => {
    const {
        waitingTickets,
        waitingTicketsSettings,
        setWaitingTicketsSettings,
        stoppedTickets,
        stoppedTicketsSettings,
        setStoppedTicketsSettings,
        removedTickets,
        removedTicketsSettings,
        setRemovedTicketsSettings
    } = useTickets();

    return (
        <>
            <fabric.Stack style={{ width: '100%' }} id={'queueContainer'} horizontal>
                <QueueTicketBar
                    componentKey={1}
                    componentText={'Laukiantys'}
                    ticketActionDisable={false}
                    assignedTicket={props.assignedTicket}
                    tickets={waitingTickets}
                    ticketsSettings={waitingTicketsSettings}
                    setTicketSettings={setWaitingTicketsSettings}
                    selectedTicket={props.selectedTicket}
                    setSelectedTicket={props.setSelectedTicket}
                    setLocationStatus={props.setLocationStatus}
                    moveTicketToLocation={props.moveTicketToLocation}
                    openSendToQueueModalWindow={props.openSendToQueueModalWindow}
                    removeTicketFromQueue={props.removeTicketFromQueue}
                    ticketActions={[TicketAction.Invite, TicketAction.Send, TicketAction.Remove]}
                />
                <QueueTicketBar
                    componentKey={2}
                    componentText={'Sustabdyti'}
                    ticketActionDisable={true}
                    assignedTicket={props.assignedTicket}
                    tickets={stoppedTickets}
                    ticketsSettings={stoppedTicketsSettings}
                    setTicketSettings={setStoppedTicketsSettings}
                    selectedTicket={props.selectedTicket}
                    setSelectedTicket={props.setSelectedTicket}
                    setLocationStatus={props.setLocationStatus}
                    moveTicketToLocation={props.moveTicketToLocation}
                    openSendToQueueModalWindow={props.openSendToQueueModalWindow}
                    removeTicketFromQueue={props.removeTicketFromQueue}
                    ticketActions={[TicketAction.Invite, TicketAction.Continue, TicketAction.Remove]}
                />
                <QueueTicketBar
                    componentKey={3}
                    componentText={'Neatvykę'}
                    ticketActionDisable={true}
                    assignedTicket={props.assignedTicket}
                    tickets={removedTickets}
                    ticketsSettings={removedTicketsSettings}
                    setTicketSettings={setRemovedTicketsSettings}
                    selectedTicket={props.selectedTicket}
                    setSelectedTicket={props.setSelectedTicket}
                    setLocationStatus={props.setLocationStatus}
                    moveTicketToLocation={props.moveTicketToLocation}
                    openSendToQueueModalWindow={props.openSendToQueueModalWindow}
                    removeTicketFromQueue={props.removeTicketFromQueue}
                    ticketActions={[TicketAction.Invite, TicketAction.Send]}
                />
            </fabric.Stack>
        </>
    );
};

export default Queue;
